/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

import { ReduxReducer } from "../../../../interface";
import { Accounts } from "../../interface";

import { State } from "./interface";

const initialState: State = {
	transactions: {},
};

const setCarParksDataModal: ReduxReducer<State, State["transactions"]> = (
	state,
	action,
) => {
	for (const [id, data] of Object.entries(action.payload)) {
		const numericId = Number(id);
		if (!Number.isNaN(numericId)) {
			state.transactions[numericId] = data;
		}
	}

	// state.transactions = action.payload;
};

const accountsCarParksDataModal = createSlice({
	name: Accounts.ConstantAccountsSlice.CAR_PARKS_DATA_MODAL,
	initialState,
	reducers: {
		setCarParksDataModal,
	},
});

export const accountsCarParksDataModalAction =
	accountsCarParksDataModal.actions;
export const accountsCarParksDataModalReducer =
	accountsCarParksDataModal.reducer;
export type accountsCarParksDataModalState = State;

export default accountsCarParksDataModal;
